<template>
  <a-modal
    :visible="visible"
    :width="700"
    wrapClassName="select-add-user-modal"
    centered
    title="Agrega nuevos usuarios"
    :bodyStyle="{ textAlign: 'center' }"
    :mask-closable="false"
    :keyboard="false"
    @cancel="handleCloseModal"
  >
    <p>Agrega usuarios por correo electrónico o directamente desde plataforma.</p>

    <a-space :size="16" class="space">
      <CardButton
        id="user-email-invitation"
        :img-src="singleEmailImage"
        title="Invita usuarios por correos electrónicos"
        description="Utiliza correos electrónicos y recibirán una invitación para unirse a tu equipo de trabajo."
        @click="handleInviteByEmail"
      />

      <CardButton
        id="user-generated-invitation"
        :img-src="multipleEmailImage"
        title="Crea usuarios con correos  autogenerados"
        description="Genera correos con contraseñas temporales que podrás asignar a cada uno de tus usuarios."
        @click="handleCreateUser"
      />
    </a-space>

    <p>
      Para conocer más sobre gestión de usuarios,
      <a href="http://securitec.pe" target="_blank" rel="noopener noreferrer">
        visita nuestro docs.
      </a>
    </p>

    <template #footer>
      <a-button @click="handleCloseModal">Cancelar</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import CardButton from "@/app/shared/components/buttons/CardButton.vue";

import singleEmailImage from "@/app/users/assets/single-email.svg?url";
import multipleEmailImage from "@/app/users/assets/multiple-email.svg?url";

defineProps<{ visible: boolean }>();

const emit = defineEmits<{
  (event: "update:visible", visible: boolean): void;
  (event: "click:invite"): void;
  (event: "click:create"): void;
}>();

const handleCloseModal = () => emit("update:visible", false);

const handleInviteByEmail = () => {
  emit("click:invite");
  handleCloseModal();
};

const handleCreateUser = () => {
  emit("click:create");
  handleCloseModal();
};
</script>

<style lang="sass" scoped>
p
  margin: 0 auto
  max-width: 500px
  text-align: center

.space
  margin: 40px 0
</style>
